// @ts-check

import { Trigger } from './Trigger'

/**
 * @typedef {Object} TimeTriggerOptions
 * @property {number} time time, in seconds, to wait before triggering
 */

/**
 * Implements a Time based trigger that fires whenever x seconds has been
 * passed.
 */
class TimeTrigger extends Trigger {
  timeoutHandler

  /**
   *
   * @param {TimeTriggerOptions} options
   */
  constructor({ time }) {
    super()
    this.timeoutHandler = setTimeout(() => this._dispatch(), time * 1000)
  }

  destroy() {
    clearTimeout(this.timeoutHandler)
    super.destroy()
  }
}

export { TimeTrigger }
